import script from "./billing-promo.vue?vue&type=script&setup=true&lang=js"
export * from "./billing-promo.vue?vue&type=script&setup=true&lang=js"

import "./billing-promo.vue?vue&type=style&index=0&id=3f3b55ed&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f3b55ed"]])

export default __exports__